import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import {StaticValueService} from '../../services/static-value.service'

@Component({
  selector: 'app-contact-number',
  templateUrl: './contact-number.component.html',
  styleUrls: ['./contact-number.component.css']
})
export class ContactNumberComponent implements OnInit {
  @Input() number:any;
  @Input() isPersonal:any;
  @Input() require:Boolean;
  @Output() numberChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() isChildFormValid = new EventEmitter<boolean>();

  public mask="";
  public staticData: any;
  public countryCodes:any;
  public countryCode: any;
  public maskNumber: any;
  public isEverythingLoaded = false;

  constructor(public staticService:StaticValueService) {
    this.staticService.getStaticValues().then(Data=> {
      this.staticData = Data;
      this.countryCodes = Object.keys(this.staticData['staticDD']['phoneNumberMask']);
      if (this.isPersonal) {
        this.countryCodes = Object.keys(this.staticData['staticDD']['phoneNumberMaskPersonal']);
      }


      if(this.number){
        this.countryCode = this.number.split(' ')[0];
        this.mask = this.staticData['staticDD']['phoneNumberMask'][this.countryCode];
        if (this.isPersonal) {
          this.mask = this.staticData['staticDD']['phoneNumberMaskPersonal'][this.countryCode];
        }
        setTimeout(() => {
          this.maskNumber = this.number.slice(this.countryCode.length+1);
        }, 100);
      } else {
        this.countryCode = this.countryCodes[0];
        if (this.isPersonal) {
          this.mask = this.staticData['staticDD']['phoneNumberMaskPersonal'][this.countryCode];
        } else {
          this.mask = this.staticData['staticDD']['phoneNumberMask'][this.countryCode];
        }  
      }
    }).catch(err => {
      console.log(err)
    })
   }
 
  ngOnInit() {
    setTimeout(() => {
      this.isEverythingLoaded = true;
    }, 2000);
  }


  countryCodeChange(){ 
    if(this.isEverythingLoaded){
      if (this.isPersonal) {
        this.mask = this.staticData['staticDD']['phoneNumberMaskPersonal'][this.countryCode];
      } else {
        this.mask = this.staticData['staticDD']['phoneNumberMask'][this.countryCode];
      }  
      setTimeout(() => {
        this.maskNumber="";
        this.change();
      }, 100);
    }
  }

  change(){
    if(this.isEverythingLoaded){
      this.numberChange.emit(this.countryCode + ' ' + this.maskNumber);
      this.isChildFormValid.emit(!!this.maskNumber);
    }
  }
}
